<template>
    <div class="transfer-container">
        <div class="transfer-title">
            <label>轉移</label>
        </div>
        <el-tabs v-model="activeName">
            <el-tab-pane v-if="isUsePropertyTransfer" label="樓盤轉移" name="first">
                <el-form :inline="true">
                    <el-row>
                        <el-form-item label="組別：" label-width="60px">
                            <el-select v-model="departmentRoles" placeholder="請選擇組別角色" @change="departChange">
                                <el-option v-for="(item, index) in departmentOptions" :key="index" :label="item.departmentName + '---' + item.roleName" :value="item.accountDepartmentID + ',' + item.roleID"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="樓盤類型：" label-width="90px">
                            <el-select v-model="listQuery.searchAccountPropertyType" placeholder="請選擇" @change="typeChange">
                                <el-option v-for="item in buildingTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div class="container">
                    <el-table empty-text="暫無數據" :key="tableKey" v-loading="listLoading" :data="list" fit :header-cell-style="{ background: 'rgba(80,181,255,0.15)' }" @selection-change="sortChange">
                        <el-table-column type="selection" width="55" />
                        <el-table-column label="放盤人" min-width="150px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.accountName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="編號" min-width="110px" prop="propertyID" show-overflow-tooltip />
                        <el-table-column label="物業編號" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.propertyNo ? scope.row.propertyNo : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="放盤類型" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.rentalType == 1 ? '放售' : '放租' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="放盤方式" min-width="110px" prop="topTypeWithCulture" show-overflow-tooltip />
                        <el-table-column label="標題" min-width="110px" prop="titleWithCulture" show-overflow-tooltip />
                        <el-table-column label="區域" min-width="110px" prop="regionNameWithCulture" show-overflow-tooltip />
                        <el-table-column label="地區" min-width="110px" prop="gscopeNameWithCulture" show-overflow-tooltip />
                        <el-table-column label="屋苑" min-width="110px" prop="estateNameWithCulture" show-overflow-tooltip />
                        <el-table-column label="座數及單位" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.buildingName ? scope.row.buildingName : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="樓層" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.unitFloorWithCulture ? scope.row.unitFloorWithCulture : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="分類" min-width="110px" prop="propertyCategoryWithCulture" show-overflow-tooltip />
                        <el-table-column label="價格(萬)" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ Number(scope.row.salePrice / 10000) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="租價(元)" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.rentPrice ? scope.row.rentPrice : '-' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="面積" min-width="150px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <p>實用面積: {{ scope.row.saleableArea ? scope.row.saleableArea : '-' }}</p>
                                <p>建築面積: {{ scope.row.buildingArea ? scope.row.buildingArea : '-' }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="顯示狀態" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.isHide ? '隱藏' : '顯示' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="放盤狀態" min-width="110px" prop="propertyStatusWithCulture" show-overflow-tooltip />
                        <el-table-column label="到期時間" min-width="110px" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span :class="{ red: expiredDate >= scope.row.expireTime }" v-if="scope.row.expireTime > 0">{{ scope.row.expireTime | getTime }}</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination class="bottom-right" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageCount" @pagination="getList" />
                </div>
                <el-row class="bottom-container">
                    <el-col :span="12">
                        <span>轉移至：</span>
                        <el-select v-model="newInformation" placeholder="請選擇員工" class="w160" @change="handleChange">
                            <el-option v-for="(item, index) in userOptions" :key="index" :label="item.name + '（' + dePartmentNm + '）'" :value="item.accountID + ',' + item.status" />
                        </el-select>
                    </el-col>
                    <el-col :span="12" class="btn">
                        <el-button type="primary" @click="propertyTransfer">儲存</el-button>
                        <el-button @click="getBack">返回</el-button>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane v-if="isUsePersonnelTransfer" label="人員調動" name="second">
                <el-form :inline="true" label-width="68px">
                    <el-row>
                        <el-form-item label="組別：">
                            <el-select v-model="departmentRole" placeholder="請選擇組別角色" @change="selectChange">
                                <el-option v-for="(item, index) in oldDepartments" :key="index" :label="item.departmentName + '---' + item.roleName" :value="item.accountDepartmentID + ',' + item.departmentName + ',' + item.roleID + ',' + item.roleName"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="轉移至：">
                            <el-cascader ref="cascader" filterable v-model="mobilizationQuery.newDepartmentID" placeholder="請選擇組別" :options="organizationOptions" expand-trigger="hover" :props="{ children: 'childNode', value: 'departmentID', label: 'departmentName', checkStrictly: true, emitPath: false }" :show-all-levels="false" @change="newDepartmentChange" />
                        </el-form-item>
                        <el-form-item label="角色：">
                            <el-select v-model="mobilizationQuery.newRoleName" placeholder="請選擇角色" @change="newRoleChange">
                                <el-option v-for="item in roleOptions" :key="item.roleID" :label="item.roleName" :value="item.roleID + ',' + item.roleName" />
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-button type="primary" @click="staffTransfer">儲存</el-button>
                    <el-button class="back" @click="getBack">返回</el-button>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters } from 'vuex';
export default {
    components: { Pagination },
    name: 'StaffingTransfer',
    data() {
        return {
            isUsePropertyTransfer:true,
            isUsePersonnelTransfer:true,
            userDetail: {},
            accountID: null,
            departmentRoles: '',
            dePartmentNm: '',
            departmentOptions: [],
            userOptions: [],
            total: 0,
            buildingTypes: [
                { value: 'owner', label: '個人盤' },
                { value: 'agent', label: '個人代理盤' }
            ],
            listQuery: {
                accountID: null,
                departmentID: null,
                pageIndex: 1,
                pageCount: 10,
                searchAccountPropertyType: '',
                RefStaffMananger: true
            },
            transferQuery: {
                propertyIDs: [],
                oldAccountID: null,
                newAccountID: null,
                departmentID: null
            },
            mobilizationQuery: {
                accountName: '',
                accountID: null,
                oldDepartmentName: '',
                oldDepartmentID: null,
                newDepartmentName: '',
                newDepartmentID: null,
                oldRoleName: '',
                oldRoleID: null,
                newRoleName: '',
                newRoleID: null
            },
            department: false,
            role: false,
            newDepartment: '',
            newRole: '',
            departmentRole: null,
            oldDepartments: [],
            roleOptions: [],
            newInformation: '',
            multipleSelection: '',
            departmentID: null,
            organizationOptions: [],
            activeName: '',
            tableKey: 0,
            total: 0,
            list: [],
            listLoading: false,
            importance: '',
            expiredDate: parseInt((new Date().getTime() + 5 * 24 * 60 * 60 * 1000) / 1000)
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    created() {
        this.userDetail = JSON.parse(localStorage.getItem('userDetail'));
        this.accountID = this.userDetail.accountID;
        this.departmentOptions = this.userDetail.roleList;
        // 默认选中第一条
        this.dePartmentNm = this.userDetail.roleList[0].departmentName;
        this.transferQuery.oldAccountID = this.userDetail.accountID;
        this.mobilizationQuery.accountID = this.userDetail.accountID;
        this.mobilizationQuery.accountName = this.userDetail.name;
        this.getOrganizationOptions();
        this.getUserRoles();
        this.GetUserInfoByAccountID();
        this.listQuery.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'statraPageCount') || 10;
        this.getList()
        this.getCompanyCofig()
    },
    methods: {
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.isUsePropertyTransfer = res.data.result.isUsePropertyTransfer
                    this.isUsePersonnelTransfer = res.data.result.isUsePersonnelTransfer
                    this.activeName = this.isUsePropertyTransfer ? 'first':'second'
                }
            });
        }, 
        // 楼盘转移组织selectChange
        departChange(val) {
            let arry = [];
            arry = val.split(',');
            this.newInformation = '';
            this.listQuery.departmentID = parseInt(arry[0]);
            // 判断组织权限
            this.department = false;
            this.role = false;
            this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[1]), this.organizationOptions);
            if (this.department === false || this.role === false) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'error',
                        message: '該組別和角色級別較高，無權操作，請重新选择！',
                        showClose: true
                    });
                }
            }
            this.getList();
            if (this.departmentRoles !== '' && this.listQuery.searchAccountPropertyType !== '') {
                this.getUserOptions();
            } else {
                this.userOptions = [];
            }
        },
        // 樓盤類型change
        typeChange() {
            this.newInformation = '';
            this.userOptions = [];
            this.getList();
            if (this.departmentRoles !== '' && this.listQuery.searchAccountPropertyType !== '') {
                this.getUserOptions();
            } else {
                this.userOptions = [];
            }
        },
        // 查询员工下拉
        getUserOptions() {
            var arry = [];
            arry = this.departmentRoles.split(',');
            if (this.listQuery.searchAccountPropertyType === 'owner') {
                // 個人盤
                this.axios
                    .post(this.pub.getApi().SearchMarketParticipantsUser, {
                        departmentID: parseInt(arry[0])
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            this.listQuery.departmentID = parseInt(arry[0]);
                            this.listQuery.accountID = this.accountID;
                            this.getList();
                            var me = this;
                            for (var i in me.departmentOptions) {
                                if (me.departmentOptions[i].accountDepartmentID === parseInt(arry[0])) {
                                    me.dePartmentNm = me.departmentOptions[i].departmentName;
                                }
                            }
                            let users = res.data.result;
                            me.userOptions = [];
                            for (var j in users) {
                                // 過濾掉自己和已停用員工
                                if (users[j].accountID !== me.accountID && users[j].status === 'Normal') {
                                    me.userOptions.push(users[j]);
                                }
                            }
                        }
                    });
            } else if (this.listQuery.searchAccountPropertyType === 'agent') {
                // 个人盤
                this.axios
                    .post(this.pub.getApi().SearchAgentUser, {
                        departmentID: parseInt(arry[0])
                    })
                    .then(res => {
                        if (res.data.code === 0 && res.data.result) {
                            this.listQuery.departmentID = parseInt(arry[0]);
                            this.getList();
                            var me = this;
                            for (var i in me.departmentOptions) {
                                if (me.departmentOptions[i].accountDepartmentID === parseInt(arry[0])) {
                                    me.dePartmentNm = me.departmentOptions[i].departmentName;
                                }
                            }
                            let users = res.data.result;
                            me.userOptions = [];
                            for (var j in users) {
                                if (users[j].accountID !== me.accountID && users[j].status === 'Normal') {
                                    me.userOptions.push(users[j]);
                                }
                            }
                        }
                    });
            }
        },
        // 組別下拉（樓盤轉移）
        getOrganizationOptions() {
            this.axios
                .get(this.pub.getApi().GetDepartmentsTreeByParentID, {
                    params: {
                        departmentID: this.userInfo.departmentID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.organizationOptions.push(res.data.result);
                    }
                });
        },
        // 組別下拉改變
        newDepartmentChange(val) {
            var cascaderNodes = this.$refs.cascader.getCheckedNodes();
            if (cascaderNodes[0].children.length === 0) {
                this.$refs.cascader.dropDownVisible = false;
            }
            this.newDepartment = val;
            this.getDepartmentName(val, this.organizationOptions);
        },
        getDepartmentName(val, organizationOptions) {
            for (var i = 0; i < organizationOptions.length; i++) {
                if (val === organizationOptions[i].departmentID) {
                    this.mobilizationQuery.newDepartmentName = organizationOptions[i].departmentName;
                } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                    this.getDepartmentName(val, organizationOptions[i].childNode);
                }
            }
        },
        // 角色下拉（人員調動）
        getUserRoles() {
            this.axios.get(this.pub.getApi().SerachChildRoleInfoByParentRoleID + `?parentRoleID=${this.userInfo.roleID}`).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.roleOptions = res.data.result;
                    // 过滤同级
                    var me = this;
                    for (let index = 0; index < me.roleOptions.length; index++) {
                        if (me.roleOptions[index].roleID === me.userInfo.roleID) me.roleOptions.splice(index, 1);
                    }
                }
            });
        },
        // 組別+角色下拉（人員調動）
        GetUserInfoByAccountID() {
            this.axios
                .get(this.pub.getApi().GetUserInfoByAccountID, {
                    params: {
                        accountID: this.accountID
                    }
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.oldDepartments = res.data.result.roleList;
                    }
                });
        },
        // 查詢
        getList() {
            this.listLoading = true;
            this.listQuery.accountID = this.accountID;
            this.axios.post(this.pub.getApi().SearchPropertyList, this.listQuery).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.list = res.data.result.data;
                    this.total = res.data.result.count;
                    this.listLoading = false;
                }
            });
        },
        handleChanges(val) {
            this.listQuery.departmentID = this.transferQuery.departmentID;
            this.getList();
        },
        selectChange(val) {
            this.departmentRole = val;
            let arry = [];
            arry = val.split(',');
            this.mobilizationQuery.oldDepartmentID = parseInt(arry[0]);
            this.mobilizationQuery.oldDepartmentName = arry[1];
            this.mobilizationQuery.oldRoleID = parseInt(arry[2]);
            this.mobilizationQuery.oldRoleName = arry[3];
            this.department = false;
            this.role = false;
            this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[2]), this.organizationOptions);
            if (this.department === false || this.role === false) {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'error',
                        message: '該組別和角色級別較高，無權操作，請重新选择！',
                        showClose: true
                    });
                }
                return false;
            }
        },
        getBack() {
            this.$router.push({ path: '/staffing/index' });
        },
        // 角色下拉改變
        newRoleChange(val) {
            this.newRole = val;
            let arry = [];
            arry = val.split(',');
            let arry1 = [];
            arry1 = this.departmentRole.split(',');
            this.mobilizationQuery.newRoleID = parseInt(arry[0]);
            this.mobilizationQuery.newRoleName = arry[1];
            for (var i = 0; i < this.oldDepartments.length; i++) {
                // 若新舊組別相同 則組別角色不能相同
                if (this.mobilizationQuery.newDepartmentID === parseInt(arry1[0])) {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID && this.mobilizationQuery.newRoleID === this.oldDepartments[i].roleID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '組別角色重複，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                } else {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工在該組別內已擁有角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                }
            }
        },
        // 員工下拉改變
        handleChange(val) {
            let arry = [];
            arry = val.split(',');
            this.transferQuery.newAccountID = parseInt(arry[0]);
        },
        // 樓盤轉移
        propertyTransfer() {
            if (this.departmentRoles === '') {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請選擇組別！',
                        showClose: true
                    });
                }
                return false;
            } else {
                let arry = [];
                arry = this.departmentRoles.split(',');
                // 判斷組別權限
                this.department = false;
                this.role = false;
                this.checkJurisdiction(parseInt(arry[0]), parseInt(arry[1]), this.organizationOptions);
                if (this.department === false || this.role === false) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'error',
                            message: '該組別和角色級別較高，無權操作，請重新选择！',
                            showClose: true
                        });
                    }
                    return false;
                } else if (this.multipleSelection.length === 0) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: '請至少選擇一條數據？',
                            showClose: true
                        });
                    }
                    return false;
                } else if (this.transferQuery.newAccountID === null) {
                    if (document.getElementsByClassName('el-message').length === 0) {
                        this.$message({
                            type: 'warning',
                            message: '請選擇接收樓盤的員工！',
                            showClose: true
                        });
                    }
                    return false;
                } else {
                    this.transferQuery.departmentID = parseInt(arry[0]);
                    // 判斷樓盤類型
                    if (this.listQuery.searchAccountPropertyType === 'agent') {
                        this.axios.post(this.pub.getApi().UpdatePropertyAgent, this.transferQuery).then(res => {
                            if (res.data.code === 0 && res.data.result) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: '操作成功!',
                                        showClose: true
                                    });
                                }
                                this.getList();
                            } else if (res.data.code == 1200) {
                                if (document.getElementsByClassName('el-message').length === 0) {
                                    this.$message({
                                        type: 'error',
                                        message: '選擇項中包含現已不存在的房源，請重新選擇！',
                                        showClose: true
                                    });
                                }
                            }
                        });
                    } else if (this.listQuery.searchAccountPropertyType === 'owner') {
                        this.axios
                            .post(this.pub.getApi().UpdatePropertyOwner, {
                                propertyIDs: this.transferQuery.propertyIDs,
                                accountID: this.transferQuery.newAccountID,
                                departmentID: this.transferQuery.departmentID
                            })
                            .then(res => {
                                if (res.data.code === 0 && res.data.result) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'success',
                                            message: '操作成功!',
                                            showClose: true
                                        });
                                    }
                                    this.getList();
                                } else if (res.data.code == 1200) {
                                    if (document.getElementsByClassName('el-message').length === 0) {
                                        this.$message({
                                            type: 'error',
                                            message: '選擇項中包含現已不存在的房源，請重新選擇！',
                                            showClose: true
                                        });
                                    }
                                }
                            });
                    }
                }
            }
        },
        // 检查权限
        checkJurisdiction(departmentID, roleID, organizationOptions) {
            if (this.userInfo.accountID === this.userDetail.accountID) {
                this.department = true;
                this.role = true;
            } else {
                for (var i = 0; i < organizationOptions.length; i++) {
                    if (departmentID === organizationOptions[i].departmentID) {
                        this.department = true;
                    } else if (organizationOptions[i].childNode && organizationOptions[i].childNode.length > 0) {
                        this.checkJurisdiction(departmentID, roleID, organizationOptions[i].childNode);
                    }
                }
                for (var j = 0; j < this.roleOptions.length; j++) {
                    if (roleID === this.roleOptions[j].roleID) {
                        this.role = true;
                    }
                }
            }
        },
        // table選擇
        sortChange(val) {
            this.transferQuery.propertyIDs = [];
            this.multipleSelection = val;
            for (var i = 0; i < val.length; i++) {
                this.transferQuery.propertyIDs.push(val[i].propertyID);
            }
        },
        // 人員調動
        staffTransfer() {
            let arry1 = [];
            arry1 = this.departmentRole.split(',');
            if (this.mobilizationQuery.oldDepartmentID === null || this.mobilizationQuery.oldRoleID === null || this.newDepartment === '' || this.newRole === '') {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'warning',
                        message: '請選擇轉移的組別和角色',
                        showClose: true
                    });
                }
                return false;
            }
            for (var i = 0; i < this.oldDepartments.length; i++) {
                if (this.mobilizationQuery.newDepartmentID === parseInt(arry1[0])) {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID && this.mobilizationQuery.newRoleID === this.oldDepartments[i].roleID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工已擁有該組別角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                } else {
                    if (this.mobilizationQuery.newDepartmentID === this.oldDepartments[i].accountDepartmentID) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'warning',
                                message: '員工在該組別內已擁有角色，請重新選擇！',
                                showClose: true
                            });
                        }
                        return false;
                    }
                }
            }
            this.department = false;
            this.role = false;
            this.checkJurisdiction(parseInt(this.mobilizationQuery.oldDepartmentID), parseInt(this.mobilizationQuery.oldRoleID), this.organizationOptions);
            if (this.department === true && this.role === true) {
                this.axios.post(this.pub.getApi().UserOrganizationalMobility, this.mobilizationQuery).then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'success',
                                message: '操作成功!',
                                showClose: true
                            });
                        }
                        this.$router.push({ path: '/staffing/index' });
                    } else if (res.data.code === 2031) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'error',
                                message: '員工在原組別中擁有樓盤，請先將資源進行轉移!',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (res.data.code === 2030) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'error',
                                message: '員工在原組別中擁有金幣，請先將資源進行轉移!',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (res.data.code === 2037) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'error',
                                message: '員工在原組別中擁有鑽石，請先將資源進行轉移!',
                                showClose: true
                            });
                        }
                        return false;
                    } else if (res.data.code === 2043) {
                        if (document.getElementsByClassName('el-message').length === 0) {
                            this.$message({
                                type: 'error',
                                message: '只有一個總行管理員不可以被轉移!',
                                showClose: true
                            });
                        }
                        return false;
                    }
                });
            } else {
                if (document.getElementsByClassName('el-message').length === 0) {
                    this.$message({
                        type: 'error',
                        message: '該組別和角色級別較高，無權操作，請重新选择！',
                        showClose: true
                    });
                }
                return false;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.transfer-container {
    font-family: PingFangSC-Regular, PingFang SC;
    /deep/.el-table th > .cell {
        font-size: 13px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
    }
    /deep/.el-table td,
    .el-table th span {
        height: 44px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 22px;
    }
    /deep/.el-table__header-wrapper {
        border-radius: 10px;
        height: 38px;
        background-color: rgba(80, 181, 255, 0.15);
    }
    /deep/.el-row .el-input__inner {
        border-radius: 10px;
        border: none;
        color: #000000;
        &::placeholder {
            font-size: 14px;
            color: #666666;
        }
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #0062ff;
        border-color: #0062ff;
    }
    text-align: left;
    .w160 {
        width: 160px;
    }
    .el-button {
        border-radius: 10px;
    }
    /deep/.el-table__header-wrapper {
        border-radius: 10px;
    }
    .transfer-title {
        font-size: 24px;
        margin: 0 0 20px 0;
    }
    .container {
        padding: 10px;
        background-color: white;
        border-radius: 10px;
    }
    .operation-container {
        margin: 15px 0;
    }
    .bottom-container {
        margin-top: 20px;
    }
    .red {
        color: #ed1d25;
    }
    /deep/ .el-table th {
        padding: 7px 0;
        border-top-left-radius: 10px;
    }
    .btn {
        text-align: right;
        .el-button {
            border: none;
        }
    }
    .back {
        border: none;
    }
}
</style>
